import { StoreModel } from '../../models/Index';
import { LogEvents, logger } from 'helpers/Logger';

export default function stackCash(Store: StoreModel, event: any) {
    logger.localLog('Stack banknote, success ', LogEvents.StackCash);

    return Store.shellClient.cashAcceptor.processStackCash();
}
